// This file creates a Vue instance to be used as an event bus for communication between components.
// It allows components to emit and listen for events without needing to pass props or use Vuex.
// This is useful for decoupling components and managing events in a more flexible way.
const listeners = Object.create(null);

export const EventBus = {
  $on(event, callback) {
    if (!listeners[event]) listeners[event] = [];
    listeners[event].push(callback);
  },
  $emit(event, ...args) {
    (listeners[event] || []).forEach((cb) => cb(...args));
  },
  $off(event, callback) {
    if (!event) {
      Object.keys(listeners).forEach((e) => (listeners[e] = []));
      return;
    }
    if (!callback) {
      listeners[event] = [];
      return;
    }
    listeners[event] = (listeners[event] || []).filter((cb) => cb !== callback);
  },
  $once(event, callback) {
    const once = (...args) => {
      this.$off(event, once);
      callback(...args);
    };
    this.$on(event, once);
  },
};
